import { createFileRoute } from '@tanstack/react-router';
import { redirectToLastLoopVisualization } from '@/features/visualizations/utils/redirectToLastLoopVisualization';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations/')({
  loader: async ({ params, context: { queryClient } }) => {
    await redirectToLastLoopVisualization({
      org: params.org,
      loopId: params.loopId,
      queryClient,
    });
  },
});
